import { CoreContext } from 'context/CoreContext';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
//import { FormText } from "ui/styled";
import Button from 'components/Form/Button';
import Check from 'components/Form/Check';
import { FormSeparator } from 'components/Form/Core/styled';
import { Icon } from 'components/Icon';
import { consultaContrato, enviaformalizar } from 'services/api-omni';
import { Title } from 'ui/styled';
import { theme } from 'ui/theme-color';
import {
  FormalizaBancoWrapper,
  FormalizaInfoItemContainer,
  FormalizaInfosContainer,
  FormalizaInfoTextContainer,
  FormalizaInfoTextTitle,
  FormalizaStepCheckboxContainer,
  FormalizaStepContainer,
  FormalizaStepMainContainer,
  FormalizaWarningContainer,
  FormalizaWarningTitle,
} from '../FormalizaBanco/styled';

const FormalizaBanco = ({ dados, reload }) => {
  const { setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const [loadingConsulta, setLoadingConsulta] = useState(false);

  const [stepsChecked, setStepsChecked] = useState({
    docs: false,
    contract: false,
  });

  const handleError = (error) => {
    const errorMessages = {
      400: 'Dados inválidos. Verifique as informações enviadas.',
      401: 'Você não tem permissão para realizar esta ação.',
    };
    const defaultError =
      'Ocorreu um erro ao processar a requisição. Tente novamente mais tarde.';
    const errorMessage = errorMessages[error.response?.status] || defaultError;
    toast.error(errorMessage);
  };

  const handleFormalizar = async () => {
    if (!dados?.id) {
      toast.error('Não foi possível localizar os dados');
      return;
    }
    setLoading(true);

    const payload = {
      id: dados.id,
      iddistributor: dados.distributorId,
      omniId: dados.omniId,
      contratoOmni: dados.id_contrato_omni,
    };

    try {
      const formalizar = await enviaformalizar(payload);
      if (formalizar.status === 200) {
        toast.success(
          `Enviado para formalização com sucesso. ${formalizar.message}`
        );
      } else if (formalizar.status === 400) {
        toast.error(`Falhou em enviar. ${formalizar.message}`);
      } else {
        toast.error(`Ocorreu um erro. ${formalizar.message}`);
      }
      setModal(null);
      if (reload) {
        reload();
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  // se tiver contrato vai add no texto o id do contrato, se nao tiver vai trazer nulo
  let textocontrato;
  if (dados.id_contrato_omni) {
    textocontrato = `, contrato OmniId: ${dados.id_contrato_omni}`;
  } else {
    textocontrato = '';
  }

  return (
    <FormalizaBancoWrapper title="Formalização do Banco">
      <FormalizaInfosContainer>
        <FormalizaInfoItemContainer>
          <Icon name="person" color={theme.palette.blue.main} />
          <span>
            <FormalizaInfoTextContainer>
              <FormalizaInfoTextTitle>Cliente:</FormalizaInfoTextTitle>
              <span>{dados?.customer}</span>
            </FormalizaInfoTextContainer>
            <FormalizaInfoTextContainer>
              <FormalizaInfoTextTitle>Proposta ID:</FormalizaInfoTextTitle>
              <span>{dados?.id ?? 'Não foi encontramos um ID'}</span>
            </FormalizaInfoTextContainer>
          </span>
        </FormalizaInfoItemContainer>

        <FormalizaInfoItemContainer>
          <Icon name="contract" color={theme.palette.blue.main} />
          <span>
            <FormalizaInfoTextContainer>
              <FormalizaInfoTextTitle>Contrato:</FormalizaInfoTextTitle>
              <span>{dados?.id_contrato_omni}</span>
            </FormalizaInfoTextContainer>
            <FormalizaInfoTextContainer>
              <FormalizaInfoTextTitle>Omni ID:</FormalizaInfoTextTitle>
              <span>{dados?.omniId ?? 'Não foi encontramos um ID'}</span>
            </FormalizaInfoTextContainer>
          </span>
        </FormalizaInfoItemContainer>
      </FormalizaInfosContainer>

      <FormalizaWarningContainer>
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: 0,
          }}
        >
          <Icon
            name="warning"
            color={theme.palette.warning.main}
            size={20}
            fill
          />
          <FormalizaWarningTitle>
            Validação manual necessária
          </FormalizaWarningTitle>
        </span>
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: '2rem',
          }}
        >
          <span>Não temos acesso ao status do contrato via integração.</span>
          <span>
            Consulte a Omni e verifique se o contrato foi assinado antes de
            enviar para formalização.
          </span>
        </span>
      </FormalizaWarningContainer>
      <FormSeparator />
      <FormalizaStepContainer>
        <FormalizaStepMainContainer>
          <Title small nomargin>
            Validar Documentos
          </Title>
          <span>Verifique o envio dos documentos.</span>
          <Button
            onClick={async () => {
              setModal({
                type: 'confirma_documentos',
                dados: {
                  customerId: dados.customerId,
                  proposalId: dados.id,
                  distribuidor: dados.distributorId,
                  omniId: dados.omniId,
                  bankingId: dados.bankingId,
                },
                origem: 'A Formalizar',
                reload,
              });
            }}
            color="blue"
            nospace
            mbutton
            outline
            disabled={!dados.omniId}
          >
            <Icon name="docs" color={theme.palette.blue.main} size={18} />
            Documentação
          </Button>
        </FormalizaStepMainContainer>
        <FormalizaStepCheckboxContainer>
          <Check
            label="Documentos validados"
            checked={stepsChecked.docs}
            onChange={() =>
              setStepsChecked((steps) => ({ ...steps, docs: !steps.docs }))
            }
            color={'blue'}
          />
        </FormalizaStepCheckboxContainer>
      </FormalizaStepContainer>

      <FormalizaStepContainer>
        <FormalizaStepMainContainer>
          <Title small nomargin>
            Consultar contrato
          </Title>
          <span>Verifique se o contrato foi assinado na Omni.</span>
          <div
            style={{
              display: 'flex',
              gap: '8px',
            }}
          >
            <Button
              onClick={() =>
                window.open('https://www.omnifacil.com.br/', '_blank')
              }
              color="blue"
              nospace
              mbutton
              outline
              disabled={!dados.omniId}
            >
              <Icon
                name="open_in_new"
                color={theme.palette.blue.main}
                size={18}
              />
              Omni
            </Button>
            <Button
              onClick={async () => {
                setLoadingConsulta(true);
                try {
                  const contrato = await consultaContrato(dados.id);
                  toast.info(`Status do contrato: ${contrato?.message}`);
                } catch (err) {
                  console.error(err);
                } finally {
                  setLoadingConsulta(false);
                }
              }}
              color="orange"
              loading={loadingConsulta}
              nospace
              outline
              mbutton
              disabled={loadingConsulta || !dados.id_contrato_omni}
            >
              Consulta contrato
            </Button>
          </div>
        </FormalizaStepMainContainer>
        <FormalizaStepCheckboxContainer>
          <Check
            label="Contrato validado"
            checked={stepsChecked.contract}
            onChange={() =>
              setStepsChecked((steps) => ({
                ...steps,
                contract: !steps.contract,
              }))
            }
            color={'blue'}
          />
        </FormalizaStepCheckboxContainer>
      </FormalizaStepContainer>

      <Button
        onClick={handleFormalizar}
        disabled={loading || !stepsChecked.docs || !stepsChecked.contract}
        color="blue"
      >
        {loading ? 'Enviando...' : 'Enviar Formalizar'}
      </Button>
    </FormalizaBancoWrapper>
  );
};

FormalizaBanco.propTypes = {
  dados: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
  reload: PropTypes.func,
};
export default FormalizaBanco;
